
  import EditGeneralView from '../../components/ViewTypes/EditGeneralView.vue'
  import { Vue, Prop, PropSync, Component, Emit, Watch } from 'vue-property-decorator'

  @Component({
    components: {
      EditGeneralView
    }
  })
  export default class Table extends Vue  {
    //Prop
    @Prop() readonly bridges!: Array<object>
    @Prop() readonly headers!: Array<object>

    //Can probably remove sync
    @PropSync('editDialog', { type: Boolean }) syncEditDialog!: boolean
    @PropSync('viewDialog', { type: Boolean }) syncViewDialog!: boolean

    //Data
    dialog = false
    search = ""
    addingNewBridge = false
    editedItem: any = {
      cityId: null,
      countyId: null,
      stateId: null,
      ownershipCity: null,
      ownershipCounty: null,
      ownershipState: null,
      sdFo: null,
      yearBuilt: null,
      entity: null,
      permitRating: null,
      paseo: null,
      roadway: null,
      id: -1,
      lat: 34.4127176,
      lng: -118.5533852
    }


    //LifeCycle

    //Methods
    public save(editedItem: any): void {
      this.$store.dispatch('bridge/storeBridge', editedItem)
    }

    public updateMarker(event: any): void {
      this.editedItem.lat = event.lat()
      this.editedItem.lng = event.lng()
    }

    //getters
    get getReload(): boolean {
      return this.$store.getters['bridge/getReload']
    }
    get getMessage(): string {
      return this.$store.getters['bridge/getMsg']
    }
    get getDeletePermissions(): string {
      return this.$store.getters['auth/getPermissions'].includes('Bridge Admin')
    }
    get getEditPermissions(): string {
      return this.$store.getters['auth/getPermissions'].includes('Bridge Editor') ||
              this.$store.getters['auth/getPermissions'].includes('Bridge Admin')
    }

    //Watch
    @Watch('getReload')
    reload(val: boolean) {
      if(val && this.addingNewBridge == true) {
        this.$store.dispatch('bridge/getBridges')
        this.$store.commit('bridge/setReload', false)
        this.addingNewBridge = false
      }
    }

    //Emits
    @Emit('viewItem')
    viewItem(item: object) {
      this.$store.commit('bridge/setMsg', "")
      return item
    }
    @Emit('editItem')
    editItem(item: object) {
      return item
    }
    @Emit('deleteItem')
    deleteItem(item: object) {
      return item
    }
    @Emit('goToItem')
    goToItem(item: any, row: any) {
      // @ts-ignore: I can't seem to add this to typescript correctly
      this.$refs.viewTable.selection = {}
      const selectState = (row.isSelected) ? false : true;
      row.select(selectState);
      return item
    }
  }
